import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import dayjs from "dayjs";
const reportsApi = factory.get("reports");

const initialState = {
  data: [],
  total: 0,
  loading: false,
  dialog: {
    open: false,
    data: [],
    total: 0,
    name: "",
  },
  filters: {
    target: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      user_id: null,
      is_supervisor: 1,
    },
    targetSummery: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      user_id: null,
    },
    salesCustomers: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      user_id: null,
      cabinet: null,
    },
    subscriptions: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      is_free: "1",
    },
    maintenance: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
    },
    newCustomersTasks: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
    },
    cabinets: {},
    cabinetsByDate: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
    },
    poles: {
      cabinet_id: null,
    },
    kpi: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      // user_id: null,
    },
  },
  payload: [],
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setReports: (state, action) => {
      state.data = action.payload.data;
      state.total = action.payload.total;
    },
    clearReports: (state) => {
      state.data = [];
      state.total = 0;
      state.payload = [];
    },
    setFilters: (state, { payload }) => {
      state.filters[payload.type] = {
        ...state.filters[payload.type],
        ...payload.data,
      };
    },
    setDialog: (state, { payload }) => {
      state.dialog.open = !state.dialog.open;
      state.dialog.name = payload || "";
      state.dialog.data = [];
    },
    setDialogData: (state, { payload }) => {
      state.dialog.data = payload.data || [];
      state.dialog.total = payload.total || 0;
    },
    setDialogLoading: (state) => {
      state.dialog.loading = !state.dialog.loading;
    },
    setPayload: (state, { payload }) => {
      state.payload = payload;
    },
  },
});

export const {
  setLoading,
  setReports,
  clearReports,
  setDialog,
  setDialogOpen,
  setFilters,
  setDialogData,
  setDialogLoading,
  setPayload,
} = reportsSlice.actions;

export default reportsSlice.reducer;

// Axios
export const fetch = (reportName) => async (dispatch, getState) => {
  try {
    dispatch(clearReports());
    dispatch(setLoading());
    const filters = getState().reports.filters;
    const response = await reportsApi[reportName](filters[reportName]);
    if (response.data.payload) {
      dispatch(setPayload(response.data.payload));
    }
    dispatch(setReports(response.data));
    dispatch(setLoading());
  } catch (error) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: error.response.data.message,
        type: "error",
      })
    );
  }
};

export const targetSummary = () => async (dispatch, getState) => {
  try {
    dispatch(setDialogLoading());
    const filters = getState().reports.filters.targetSummery;
    const response = await reportsApi.targetSummary(filters);
    dispatch(setDialogData(response.data));
    dispatch(setDialogLoading());
  } catch (error) {
    dispatch(setDialogLoading());
    dispatch(
      showNotification({
        message: error.response.data.message,
        type: "error",
      })
    );
  }
};

export const poles = () => async (dispatch, getState) => {
  try {
    dispatch(setDialogLoading());
    const { cabinet_id } = getState().reports.filters.poles;
    const response = await reportsApi.poles(cabinet_id);
    dispatch(setDialogData(response.data));
    dispatch(setDialogLoading());
  } catch (error) {
    dispatch(setDialogLoading());
    dispatch(
      showNotification({
        message: error.response.data.message,
        type: "error",
      })
    );
  }
};

export const Reports = {
  fetch,
  targetSummary,
  poles,
};
